import React, { useState } from "react";
import ModalWrapper from "./ModalWrapper";
import { UilSearch } from "@iconscout/react-unicons";
import { useFormContext } from "react-hook-form";
import { UilAngleDown, UilAngleUp } from "@iconscout/react-unicons"

const years = Array.from({ length: 30 }, (_, i) => 2025 - i);

export default function YearModal({ name, label, onClose, error }) {
  const { setValue, watch } = useFormContext();
  const [query, setQuery] = useState("");
  const selectedYear = parseInt(watch(name));

  const filtered = query
    ? years.filter((y) => y.toString().includes(query))
    : years.filter((y) => y <= 2025 && y >= 1980);

  const [open, setOpen] = useState(false);

  return (
    <>
      <div>
        {label && <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>}
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="flex items-center justify-between w-full p-3 bg-input border rounded-md text-left text-sm mb-2"
        >
          <span>{selectedYear || "Select year"}</span>
          {open ? (
            <UilAngleUp className="h-4 w-4 text-gray-500" />
          ) : (
            <UilAngleDown className="h-4 w-4 text-gray-500" />
          )}
        </button>
        {error && <p className="text-red-500 text-sm">{error}</p>}
      </div>

      {open && (
        <ModalWrapper onClose={() => setOpen(false)}>
          <div className="flex items-center border rounded-md px-2 py-1 mb-4 bg-blue-50">
            <UilSearch className="text-gray-500 w-4 h-4 mr-2" />
            <input
              type="text"
              placeholder="Search year..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="flex-1 bg-transparent outline-none text-sm"
            />
          </div>

          <ul className="grid grid-cols-1 gap-2">
            {filtered.map((year) => (
              <li key={year}>
                <button
                  onClick={() => {
                    setValue(name, year);
                    setOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 rounded border-b hover:bg-blue-50  ${selectedYear === year ? 'bg-blue-50 ' : " "}`}
                >{year}
                  {selectedYear === year && <span className="ml-2 text-xs text-blue-700">(Selected)</span>}
                </button>
              </li>
            ))}
          </ul>
        </ModalWrapper>
      )}
    </>
  );
}
